import { AppState } from '@redux/reducers';
import { createSelector } from 'reselect';

export const selectOfferAgreements = createSelector(
  (state: AppState) => state.OfferPage,
  (offerPage) => offerPage.offerAgreements,
);
